<template>
    <div class="row">
        <div class="col-lg-7">
            <div class="card-title clearfix">
                <h4 class="d-inline-block">Certificate Details</h4>
                <span v-if='editMode' class="float-end">
                    <button @click="onSaveClick" class="btn btn-success"> Save </button>&nbsp;
                    <button @click="onCancelClick" class="btn btn-secondary "> Cancel </button>&nbsp;
                </span>
                <span v-else class="float-end">
                    <button type="button" @click="onEditClick" class="btn btn-primary" :disabled="!certificate">
                        Edit
                    </button>
                </span>
            </div>
            <div class="card">
                <div class="card-body" v-if="certificate">
                    <input-field :inlineField="true" label="Name" type="text" v-model="certificate.commonName"
                        :validate="getValidation('Name')" :editable="false" :toolTip="'Certificate name'" />
                    <input-field :inlineField="true" label="Sans" type="multiselect" v-model="certificate.sans"
                        :validate="getValidation('Sans')" :editable="editMode" :toolTip="'Certificate Sans'" />
                </div>
                <div class="card-body d-flex justify-content-center align-items-center" v-else>
                    <div class="spinner-border spinner-border-sm" role="status" v-if="reading">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div v-else>
                        <span>No data found!</span>
                    </div>
                </div>
            </div>
            <div class="card-title clearfix">
                <h4 class="d-inline-block">Admin Details</h4>
            </div>
            <div class="card">
                <div class="card-body" v-if="certificate">
                    <input-field :inlineField="true" label="Email" type="text" v-model="certificate.admin.email"
                        :placeholder="'aut@aqfer.com'" :validate="getValidation('Email')" :editable="editMode"
                        :toolTip="`Admin's Email`" />
                    <input-field :inlineField="true" label="Phone" type="text" v-model="certificate.admin.phone"
                        :validate="getValidation('Phone')" :editable="editMode" :toolTip="`Admin's Phone no`" />
                    <input-field :inlineField="true" label="First Name" type="text"
                        v-model="certificate.admin.firstName" :validate="getValidation('First Name')"
                        :editable="editMode" :toolTip="`Admin's First Name`" />
                    <input-field :inlineField="true" label="Last Name" type="text" v-model="certificate.admin.lastName"
                        :validate="getValidation('Last Name')" :editable="editMode" :toolTip="`Admin's Last NAme`" />
                </div>
                <div class="card-body d-flex justify-content-center align-items-center" v-else>
                    <div class="spinner-border spinner-border-sm" role="status" v-if="reading">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div v-else>
                        <span>No data found!</span>
                    </div>
                </div>
            </div>
            <div class="card-title clearfix">
                <h4 class="d-inline-block">Organization Details</h4>
            </div>
            <div class="card">
                <div class="card-body" v-if="certificate">
                    <input-field :inlineField="true" label="Name" type="text" v-model="certificate.org.organizationName"
                        :validate="getValidation(`Organization's Name`)" :editable="editMode"
                        :toolTip="`Organization's Name`" />
                    <input-field :inlineField="true" label="Unit" type="text" v-model="certificate.org.organizationUnit"
                        :editable="editMode" :toolTip="`Organization's Unit`" />
                    <input-field :inlineField="true" label="Country" type="text" v-model="certificate.org.country"
                        :validate="getValidation('Country')" :editable="editMode" :toolTip="`Organization's Country`" />
                    <input-field :inlineField="true" label="State" type="text" v-model="certificate.org.state"
                        :validate="getValidation('State')" :editable="editMode" :toolTip="`Organization's State`" />
                    <input-field :inlineField="true" label="Locality" type="text" v-model="certificate.org.locality"
                        :validate="getValidation('Locality')" :editable="editMode"
                        :toolTip="`Organization's Locality`" />
                    <input-field :inlineField="true" label="Address Line 1" type="text"
                        v-model="certificate.org.addressLineOne" :validate="getValidation('Address Line 1')"
                        :editable="editMode" :toolTip="`Organization's Address Line 1`" />
                    <input-field :inlineField="true" label="Address Line 2" type="text"
                        v-model="certificate.org.addressLineTwo" :editable="editMode"
                        :toolTip="`Organization's Address Line 2`" />
                    <input-field :inlineField="true" label="Phone" type="text" v-model="certificate.org.phone"
                        :validate="getValidation(`Organization's Phone`)" :editable="editMode"
                        :toolTip="`Organization's Phone no`" />
                    <input-field :inlineField="true" label="Postal Code" type="text"
                        v-model="certificate.org.postalCode" :validate="getValidation('Postal Code')"
                        :editable="editMode" :toolTip="`Organization's Postal Code`" />
                </div>
                <div class="card-body d-flex justify-content-center align-items-center" v-else>
                    <div class="spinner-border spinner-border-sm" role="status" v-if="reading">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div v-else>
                        <span>No data found!</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-5">
            <div class="card-title clearfix">
                <h4 class="d-inline-block">Certificate Expiry Details</h4>
            </div>
            <div class="card card-body">
                <div v-if="!expiryLoading">
                    <input-field :inlineField="true" label="Expires On" type="text" v-model="expiry" :editable="false"
                        :toolTip="`Expiry of the Deployed Certificate`"/>
                </div>
                <div v-else class="text-center">
                    <div class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
            <div class="card-title clearfix">
                <h4 class="d-inline-block">Deployment Status</h4>
                <div class="float-end gap-2 d-flex">
                    <button type="button" class="btn btn-primary" @click="onRefreshClick" :disabled="readingDeployment">
                        <div v-if="readingDeployment" class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <i v-else class="fa fa-refresh"></i>
                    </button>
                </div>
            </div>
            <div class="card card-body">
                <div v-if="certDeploy">
                    <input-field :inlineField="true" label="Status" type="text" v-model="certDeploy.deployment_status"
                        :editable="false" />
                    <input-field :inlineField="true" label="Description" type="textarea"
                        v-model="certDeploy.description" :editable="false" />
                    <input-field :inlineField="true" label="Name" type="text" v-model="certDeploy.commonName"
                        :editable="false" />
                    <input-field :inlineField="true" label="Warnings" type="object" v-model="certDeploy.warnings"
                        :editable="false" />
                </div>
                <div v-else class="text-center">
                    <div class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex/dist/vuex.cjs.js';
import InputField from "../../components/InputField.vue";
export default {
    components: { InputField },
    name: "Certificate Details",
    data() {
        return {
            certDeploy: null,
            certificate: null,
            signedCertificate: null,
            snapshot: null,
            editMode: false,
            reading: false,
            readingDeployment: false,
            intervalCount: 0,
            intervalId: null,
            expiry: "",
            expiryLoading: false,
        }
    },
    methods: {
        ...mapActions({
            fetchCertificate: "aut/fetchCertificate",
            updateCertificate: "aut/updateCertificate",
            getDeploymentStatus: "aut/getCertificateDeploymentStatus",
            getCertificateExpiry: "aut/getCertificateExpiry",
            showModal: "showModal"
        }),
        async readCertificate(forceGet) {
            let response = {};
            this.reading = true;
            if (forceGet || !this.$route.params.data) {
                try {
                    response = await this.fetchCertificate(this.$route.params.id);
                } catch (error) {
                    let err = null;
                    if (error.response.data.error) err = error.response.data.error;
                    else err = error.message;
                    let toastOptions = {
                        message: err || "Something went wrong while fetching certificate. Please contact support.",
                        type: "error"
                    }
                    console.error("Error in fetching certificate: ", err);
                    this.$store.dispatch("addToast", toastOptions);
                }
            } else {
                response["data"] = JSON.parse(this.$route.params.data);
            }
            this.certificate = await response.data;
            this.snapshot = JSON.parse(JSON.stringify(this.certificate)) // deep clone
            this.$emit("setCertificate", this.certificate);
            this.reading = false;
        },
        async readCertificateExpiry() {
            this.expiryLoading = true;
            this.expiry = "";
            await this.getCertificateExpiry(this.$route.params.id).then(response => {
                this.expiry = response.data?.expiry ? response.data.expiry : "NA";
            }).catch(error => {
                let err = null;
                if (error.response.data.error) err = error.response.data.error;
                else err = error.message;
                console.error("Error in fetching certificate expiry: ", err);
            })
            this.expiryLoading = false;
        },
        async readCertificateDeployment() {
            this.readingDeployment = true;
            await this.getDeploymentStatus(this.$route.params.id)
                .then(response => {
                    this.certDeploy = response.data;
                    this.$emit("setCertDeploy", this.certDeploy);
                }).catch(error => {
                    let err = null;
                    if (error.response.data.error) err = error.response.data.error;
                    else err = error.message;
                    let toastOptions = {
                        message: err || "Something went wrong while fetching certificate deployment status. Please contact support.",
                        type: "error"
                    }
                    this.$store.dispatch("addToast", toastOptions);
                })
            this.readingDeployment = false;
        },
        startDeploymentPolling() {
            this.readCertificateDeployment(); // initial call
            this.readCertificateExpiry();

            this.intervalId = setInterval(() => {
                if (this.intervalCount >= 10) {
                    clearInterval(this.intervalId);
                    return;
                }
                this.readCertificateDeployment();
                this.readCertificateExpiry();
                this.intervalCount++;
            }, 10000); // update deployment status every 10s for 'ten' times
        },
        onEditClick() {
            this.editMode = true;
        },
        onCancelClick() {
            this.editMode = false;
            this.certificate = JSON.parse(JSON.stringify(this.snapshot)); // restore
        },
        onRefreshClick() {
            this.readCertificateDeployment();
        },
        async onSaveClick() {
            this.updateCertificate(this.certificate)
                .then(response => {
                    this.editMode = false;
                    this.readCertificate(true);
                    this.readCertificateExpiry();
                }).catch(error => {
                    let err = null;
                    if (error.response.data.error) err = error.response.data.error;
                    else err = error.message;
                    let toastOptions = {
                        message: err || "Something went wrong while updating certificate. Please contact support.",
                        type: "error"
                    }
                    console.error("Error in update: ", err);
                    this.$store.dispatch("addToast", toastOptions);
                })
        },
        getValidation(name) {
            return [
                { type: 'required', errMsg: `${name} is required` }
            ]
        }
    },
    watch: {
        '$store.state.aut.getCertStatusTrigger': {
            handler(newValue) {
                this.readCertificateDeployment();
            },
            deep: true
        },
        '$store.state.aut.renewCertTrigger': {
            handler(newValue) {
                this.intervalCount = 0;
                this.readCertificate(true);
                this.readCertificateExpiry();
                this.startDeploymentPolling();
            },
            deep: true
        },
    },
    beforeMount() {
        this.readCertificate(false);
        this.readCertificateExpiry();
        this.startDeploymentPolling();
    },
    beforeUnmount() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },

    emits: ["setCertificate", "setCertDeploy"]
};
</script>

<style scoped></style>